import ErrorStatus from '$shared/constants/ErrorStatus';
import { ApplicationEvent } from '$shared/constants/ApplicationEvent';
import application from './application';

class DispatchEvent {
  public byStatus(status: number): void {
    switch (status) {
      case ErrorStatus.Maintenance: {
        application.dispatchEvent(ApplicationEvent.OnMaintenance);
        break;
      }
      case ErrorStatus.UnAuthourized: {
        application.dispatchEvent(ApplicationEvent.OnUnauthorized);
        break;
      }
    }
  }
}

export const dispatchEvent = new DispatchEvent();
